import React from 'react';
import ServicePage from '../components/ServicePage';
import img from '../assets/service3_1.jpeg';

const overview = [
  'Edge-Level Security Solutions including firewall, UTM, and application access security',
  'LAN & Data Security Solutions covering application security, DLP, data protection, and intrusion prevention systems (IPS).',
  'Host-Level Protection Solutions including antivirus (AV), malware protection, and ransomware protection.',
  'Cloud & Email Security Solutions for secure cloud workloads and enterprise email protection',
  'Comprehensive Cyber Security Services enabling end-to-end threat prevention and risk mitigation.',
  'SIEM, EDR & XDR Solutions for real-time threat detection and response.'
];

const features = [
  { title: 'Cybersecurity',      text: 'Advanced threat protection and security monitoring' },
  { title: 'Data Backup',        text: 'Automated backup solutions with disaster recovery' },
  { title: 'Cloud Storage',      text: 'Scalable cloud storage with high availability' },
  { title: 'Access Management',  text: 'Identity and access management solutions' }
];

function SecurityService() {
  return (
    <ServicePage
      title="Security Services"
      subtitle="Comprehensive security and cloud infrastructure"
      img={img}
      imgAlt="Security Services"
      overview={overview}
      features={features}
      backAnchor="security"
    />
  );
}

export default SecurityService;
